import React from 'react';
import {useField} from 'formik';
import {useIntl} from 'react-intl';
import InputText from '../../../../common/components/ui/InputText';
import {useOrderInvoiceFormContext} from "../../contexts/OrderInvoiceFormContext";

const FieldAddress = () => {
  const intl = useIntl();
  const labelText = intl.formatMessage({
    id: 'orderInvoice-form-address',
    defaultMessage: 'Address'
  });
  const placeholder = intl.formatMessage({
    id: 'default-placeholder',
    defaultMessage: 'Write here'
  });
  const [field, meta] = useField({name: 'address'});
  const {showAllErrors} = useOrderInvoiceFormContext();

  return (
    <InputText
      {...field}
      {...meta}
      variant={'full'}
      id={field.name}
      label={labelText}
      defaultValue={field.value}
      placeholder={placeholder}
      autoComplete={'address-level4'}
      showErrorOnSubmit={showAllErrors}
    />
  );
};

export default FieldAddress;
